<template>
  <div class="shadow mt-8 border sm:rounded-lg">
    <div class="p-4 pb-5 sm:px-6 border-b bg-light-grey sm:rounded-t-lg">
      <h3 class="text-lg leading-6 font-medium text-vice-teal-700">
        <slot name="header"></slot>
      </h3>
    </div>

    <div class="px-4 py-4 bg-white sm:px-6 flex" :class="{ 'sm:rounded-b-lg': !hasFooterSlot }">
      <slot></slot>
    </div>

    <div class="p-4 sm:px-6 bg-white border-t sm:rounded-b-lg" v-if="hasFooterSlot">
      <div class="flex justify-end gap-2">
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VicePanel',
  computed: {
    hasFooterSlot() {
      return !!this.$slots.footer;
    },
  },
};
</script>
